<template>
  <group-list></group-list>
</template>

<script>
import GroupList from "@/components/GroupList";

export default {
  components: {
    GroupList
  }
};
</script>